import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';

export default class TpLocationItem {
  constructor(item) {
    if (item === undefined) {
      this.TpLocationId = '';
      this.BravoClientId = '';
      this.ThirdPartyLocationId = '';
      this.ThirdPartyClientId = '';
      this.ThirdPartyClientName = '';
      this.ThirdPartyLocationName = '';
      this.ThirdPartyLocationAddress = '';
      this.ThirdPartyLocationCity = '';
      this.ThirdPartyLocationState = '';
      this.ThirdPartyLocationCountry = '';
      this.ThirdPartyLocationZipCode = '';
      this.ThirdPartyLocationPhone = '';
      this.ThirdPartyClientLocationId = '';
      this.IsActive = null;
      this.ThirdPartyLevel1Id = '';
      this.ThirdPartyLevel2Id = '';
      this.ThirdPartyLevel3Id = '';
      this.ThirdPartyLevel4Id = '';
      this.ThirdPartyLevel5Id = '';
      this.ThirdPartySource = '';
      this.CreatedOn = null;
      this.ModifiedOn = null;
      this.CreatedBy = null;
      this.ModifiedBy = null;
      return;
    }
    this.TpLocationId = item.tpLocationId;
    this.BravoClientId = item.bravoClientId;
    this.ThirdPartyLocationId = item.thirdPartyLocationId;
    this.ThirdPartyClientId = item.thirdPartyClientId;
    this.ThirdPartyClientName = item.thirdPartyClientName;
    this.ThirdPartyLocationName = item.thirdPartyLocationName;
    this.ThirdPartyLocationAddress = item.thirdPartyLocationAddress;
    this.ThirdPartyLocationCity = item.thirdPartyLocationCity;
    this.ThirdPartyLocationState = item.thirdPartyLocationState;
    this.ThirdPartyLocationCountry = item.thirdPartyLocationCountry;
    this.ThirdPartyLocationZipCode = item.thirdPartyLocationZipCode;
    this.ThirdPartyLocationPhone = item.thirdPartyLocationPhone;
    this.ThirdPartyClientLocationId = item.thirdPartyClientLocationId;
    this.IsActive = item.isActive;
    this.ThirdPartyLevel1Id = item.thirdPartyLevel1Id;
    this.ThirdPartyLevel2Id = item.thirdPartyLevel2Id;
    this.ThirdPartyLevel3Id = item.thirdPartyLevel3Id;
    this.ThirdPartyLevel4Id = item.thirdPartyLevel4Id;
    this.ThirdPartyLevel5Id = item.thirdPartyLevel5Id;
    this.ThirdPartySource = item.thirdPartySource;
    this.CreatedOn = item.createdOn;
    this.ModifiedOn = item.modifiedOn;
    this.CreatedBy = item.createdBy;
    this.ModifiedBy = item.modifiedBy;

    this.SelectedInList = false;
  }

  static displayedInList = 'Name';

  static NameOfTheIdField() {
    return 'TpLocationId';
  }
  static nameOfTheItemDetailList() {
    return 'SurveyDatum';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];

  static BoolFields = ['IsActive'];

  static FieldsToShowInListTable = [
    {
      tabName: 'Main',
      tabLabel: 'Main',
      icon: 'fa-solid fa-users',
      data: [
        { name: 'Questions', label: 'Questions', width: TabListTableCellWidthEnum.TwoLines, className: 'text-left' },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'TpLocationId',
        orderById: 'TpLocationId',
        data: 'TpLocationId',
        minWidth: 50,
      },
      {
        label: 'Third-Party Client Name',
        orderById: 'ThirdPartyClientName',
        data: 'ThirdPartyClientName',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Third-Party LocationId',
        orderById: 'ThirdPartyLocationId',
        data: 'ThirdPartyLocationId',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Third-Party Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Third-Party ClientId',
        orderById: 'ThirdPartyClientId',
        data: 'ThirdPartyClientId',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Third-Party Location Name',
        orderById: 'ThirdPartyLocationName',
        data: 'ThirdPartyLocationName',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Address',
        orderById: 'ThirdPartyLocationAddress',
        data: 'ThirdPartyLocationAddress',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'City',
        orderById: 'ThirdPartyLocationCity',
        data: 'ThirdPartyLocationCity',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'State',
        orderById: 'ThirdPartyLocationState',
        data: 'ThirdPartyLocationState',
        className: 'text-center',
        minWidth: 50,
      },
      {
        label: 'Country',
        orderById: 'ThirdPartyLocationCountry',
        data: 'ThirdPartyLocationCountry',
        className: 'text-center',
        minWidth: 50,
      },
    ];
  }
}
